@import (reference) '../../../../constants/spacing.module.less';

.instruction-text {
  font-weight: 500;
}

.warehouse-text {
  color: var(--grey-600);
}

.drawer-section {
  background-color: var(--white);
  border-radius: @space-8;
  border: 1px solid var(--grey-300);
  padding: @space-16;
  min-height: fit-content;
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.resizable-section {
  flex: 0.5;
  justify-content: space-around;
}

.banner {
  width: max-content;
  border-radius: @space-4;
}
